module.exports = __webpack_public_path__ + "img/my_workers.a84d5dd.svg";